/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */

import {
  DEFAULT_TIME_ZONE_DISPLAY,
  isTimeZoneDisplayPreference,
} from "@lemonadetraining/contracts";
import { createPreferenceMirror } from "./preferenceMirror";

/** Device-local echo of Users/{uid}/Settings/preferences.timeZoneDisplay; never the zone. */
export const TIME_ZONE_DISPLAY_STORAGE_KEY = "lemonade-time-zone-display";

const mirror = createPreferenceMirror({
  key: TIME_ZONE_DISPLAY_STORAGE_KEY,
  field: "timeZoneDisplay",
  isValid: isTimeZoneDisplayPreference,
  fallback: DEFAULT_TIME_ZONE_DISPLAY,
});

export const readTimeZoneDisplayMirror = mirror.read;
export const readTimeZoneDisplayMirrorUid = mirror.readUid;
export const writeTimeZoneDisplayMirror = mirror.write;
export const clearTimeZoneDisplayMirror = mirror.clear;
